export var query = "mutation markCheckoutAsCompleted($id: String!) {\n  checkout {\n    markCheckoutAsCompleted(id: $id)\n  }\n}\n";
//# sourceMappingURL=markCheckoutAsCompleted.graphql.js.map